import React, { Component } from 'react'
import get from 'lodash/get'
import PropTypes from 'prop-types'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { Link, withRouter } from 'react-router-dom'

import * as ROUTES from 'config/routes'
import { API_PENDING, API_SUCCESS, API_FAIL } from 'redux/api/constants'
import { Col, Row, Spinner } from 'elements'
import { formSubmit } from 'utils/form'
import { getClientConfig, updateClientConfig } from 'redux/modules/model/client'
import { clientConfigDetailsSelector, clientConfigDetailsStatusSelector } from 'redux/selectors'
import { ClientConfigForm } from 'smart-components'
import { PageContentTitle } from 'components'
import { withClientId } from 'hocs'
import './index.scss'


const COMPONENT_CSS_CLASSNAME = 'clientconfig-edit'
const bemE = (suffix) => `${COMPONENT_CSS_CLASSNAME}__${suffix}`

class ClientConfigEdit extends Component {
  static propTypes = {
    clientId: PropTypes.string.isRequired,
    getClientConfig: PropTypes.func.isRequired,
    match: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    clientConfig: PropTypes.object,
    clientConfigDetailsStatus: PropTypes.string.isRequired,
    updateClientConfig: PropTypes.func.isRequired
  };

  componentDidMount() {
    const { clientId, getClientConfig, match: { params: { targetClientId } } } = this.props
    getClientConfig({ targetClientId })
  }

  handleSubmit = (values) => {
    const { clientId, history, clientConfig, updateClientConfig } = this.props
    const targetClientId = get(clientConfig, 'clientId');
    const changes = {
      liveViewEnabled: values.liveViewEnabled,
      visitCalculationEnabled: values.visitCalculationEnabled,
      liveVisitEnabled: values.liveVisitEnabled,
      liveVisitGracePeriod: values.liveVisitGracePeriod,
      liveVisitMergePeriod: values.liveVisitMergePeriod
    }
    return formSubmit(updateClientConfig, { clientId, targetClientId, changes })
      .then(() => history.push(ROUTES.CLIENT_CONFIG))
  };

  render() {
    const { clientConfig, clientConfigDetailsStatus } = this.props
    const initialValues = clientConfig ? {
      ...clientConfig
    } : null

    return (
      <Row>
        <Col xs={24} sm={12} md={10}>
          <p className={bemE('back')}><Link to={ROUTES.CLIENT_CONFIG}>&laquo; Back</Link></p>
          <PageContentTitle>Edit client config</PageContentTitle>
          {API_PENDING === clientConfigDetailsStatus && <Spinner />}
          {API_SUCCESS === clientConfigDetailsStatus && <ClientConfigForm initialValues={initialValues} onSubmit={this.handleSubmit} />}
          {API_FAIL === clientConfigDetailsStatus && <h2>Client Config id is invalid</h2>}
        </Col>
      </Row>
    )
  }
}

export const selector = createStructuredSelector({
  clientConfig: clientConfigDetailsSelector,
  clientConfigDetailsStatus: clientConfigDetailsStatusSelector
})

export const actions = {
  getClientConfig,
  updateClientConfig
}

export default compose(
  withRouter,
  withClientId,
  connect(selector, actions),
)(ClientConfigEdit)



// WEBPACK FOOTER //
// ./src/pages/client-config/clientconfig-edit/index.js